import { graphql } from '@guuru/graphql-common/gql';
import { CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS } from '@guuru/graphql-web';

export default graphql(
  `
    query GetChat(
      $id: ID!
      $isVisibleByExpert: Boolean
      $isVisibleByUser: Boolean
      $chatControlToken: String
    ) {
      chat(id: $id, chatControlToken: $chatControlToken) {
        ...ChatPublicFields
        messages(
          isVisibleByExpert: $isVisibleByExpert
          isVisibleByUser: $isVisibleByUser
          orderBy: { direction: asc, field: createdAt }
        ) {
          edges {
            __typename
            node {
              ...MessageFields
            }
          }
        }
      }
    }
  `,
  [CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS],
);
